export default __webpack_public_path__ + "static/media/bubble.0a532dd5.png";